import React, { Component, ChangeEvent } from 'react'
import styled from 'styled-components'
import { Input, TextBox, Text, Button, Flex } from '@revolut/ui-kit'
import { Slide } from 'components/Slide'
import { GeneralState } from 'reducers/generalReducer'
import { CONFIRMATION_CODE_LENGTH } from 'constants/common'

const RetryBtn = styled(Text).attrs({
  color: 'primary',
  variant: 'caption',
  pl: '.25rem',
})`
  cursor: pointer;
`

export type ConfirmationCodeProps = {
  setFieldValue: (field: string, value?: string) => void
  resetForm: () => void
  handleSubmit: () => void
  errors: {
    code?: string
  }
  values: {
    code?: string
  }
  general: GeneralState
  onBack: () => void
  subtitle: string
}

class ConfirmationCode extends Component<ConfirmationCodeProps> {
  componentDidUpdate(prevProps: Readonly<ConfirmationCodeProps>): void {
    const {
      values: { code = '' },
    } = this.props
    const {
      values: { code: prevCode = '' },
    } = prevProps
    if (
      prevCode.length !== CONFIRMATION_CODE_LENGTH &&
      code.length === CONFIRMATION_CODE_LENGTH
    ) {
      this.props.handleSubmit()
    }
  }

  handleRetry = () => {
    this.props.resetForm()
    this.props.onBack()
  }

  render() {
    const {
      setFieldValue,
      handleSubmit,
      errors,
      values: { code = '' },
      ...rest
    } = this.props
    const val = code.replace(/[^\d|-]/g, '')
    return (
      <Slide onSubmit={handleSubmit} title='Enter 6 digit code' {...rest}>
        <Flex flex={1} alignItems='center'>
          <Input
            variant='filled'
            name='code'
            placeholder='Code'
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              setFieldValue('code', event.target.value)
            }
            maskPattern='111-111'
            message={
              <TextBox width='100%' textAlign='right'>
                <Text variant='caption' color='grey-50'>
                  If you have not got the code for 2 minutes.
                </Text>
                <RetryBtn onClick={this.handleRetry}> Try again</RetryBtn>
              </TextBox>
            }
            error={errors.code}
            value={val}
            type='tel'
          />
        </Flex>
        <Button onClick={handleSubmit}>Continue</Button>
      </Slide>
    )
  }
}

export { ConfirmationCode }
